export default __webpack_public_path__ + "static/media/spotify-i.24ce539f.svg";